import React, { useEffect } from "react";
import cx from "clsx";
import { noop } from "rxjs";
import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { usePopper } from "react-popper";
export const AiActions = ({ commands, activeIndex, setActiveIndex, onEnter, activeCommand, usage = null, popupRef, }) => {
    const wrapperRef = React.useRef(null);
    const { styles, attributes } = usePopper(popupRef.current, wrapperRef.current, {
        placement: "bottom-start",
        // strategy: "absolute",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [0, 55], // The number 10 can be changed according to your need
                },
            },
            {
                name: "flip",
                enabled: false,
            },
        ],
    });
    useEffect(() => {
        var _a;
        (_a = wrapperRef.current
            .querySelector(".ai-popup-actions__item--active")) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            block: "nearest",
        });
    }, [activeIndex, wrapperRef]);
    return (React.createElement("div", { ...attributes.popper, style: {
            ...styles.popper,
        }, className: "ai-popup-actions__wrapper" },
        React.createElement("div", { role: "toolbar", className: "ai-popup-actions", ref: wrapperRef },
            React.createElement("div", { className: "ai-popup-actions__list" }, commands.map((group, groupIndex) => (React.createElement("div", { key: group.label, className: "ai-popup-actions__category" },
                group.label.trim() !== "" && (React.createElement("div", { className: "ai-popup-actions__category-label" },
                    React.createElement(Paragraph, { size: "xs", weight: "semibold", color: "currentColor" }, group.label))),
                group.items.map((command) => (React.createElement("div", { key: command.label, onMouseOver: () => setActiveIndex(command.index), className: cx("ai-popup-actions__item", {
                        "ai-popup-actions__item--active": activeIndex === command.index,
                    }) },
                    React.createElement("button", { onClick: () => onEnter(command.index), onFocus: noop, onKeyDown: noop, className: "ai-popup-actions__item-btn" },
                        React.createElement("div", { className: "ai-popup-actions__item-icon" },
                            React.createElement(Icon, { name: command.icon, size: command.iconSize || "M", color: "currentColor" })),
                        React.createElement("div", { className: "ai-popup-actions__item-text" },
                            React.createElement(Paragraph, { weight: "medium", color: "inherit" }, command.label)))))),
                groupIndex !== commands.length - 1 && (React.createElement("div", { className: "ai-popup-actions__category-divider" })))))),
            usage),
        (activeCommand === null || activeCommand === void 0 ? void 0 : activeCommand.options) && (React.createElement("div", { className: "ai-popup-actions__active--options" }, activeCommand.options.map((option) => (React.createElement("button", { key: option.label, onClick: () => onEnter(activeCommand.index, option), className: "ai-popup-actions__active--option" },
            React.createElement(Paragraph, { size: "xs", color: "tertiary" }, option.label))))))));
};
